import { useSelector } from "react-redux";
import { selectUser } from "../store/userSlice";
import translation from "../utils/translation";

/**
 * just a wrapper around translation[sitelang][key]
 */
export function useTranslation() {
  const { siteLang } = useSelector(selectUser);
  const locale = (key: keyof (typeof translation)["en"]) =>
    translation[siteLang][key];
  return { locale, siteLang };
}
